/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import helpers from "util/helpers";

class NewGraduate extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderReference = (reference) => {
    if (!reference) {
      return (
        <div className="referenceStars">
          <img src="/img/star.svg" alt="star" />
          <img src="/img/star.svg" alt="star" />
          <img src="/img/star.svg" alt="star" />
          <img src="/img/star.svg" alt="star" />
          <img src="/img/star.svg" alt="star" />
        </div>
      );
    }

    const stars = [];
    for (let index = 1; index <= 5; index++) {
      if (index <= reference.value) {
        stars.push(<img src="/img/star-filled.svg" alt="star" />);
      } else {
        stars.push(<img src="/img/star.svg" alt="star" />);
      }
    }

    return (
      <div className="referenceStars">
        {stars.map((el) => {
          return el;
        })}
      </div>
    );
  };

  renderTabletModeDetail = (employee) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              {/* <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10603</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {employee.position ? employee.position.name : ""}
                </td>
              </tr> */}
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans>applicantpool_city</Trans>
                  </div>
                </td>
                <td className="showGrup">{employee.city}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td>
                  <div className="tableTitle">
                    * <Trans desc="Sertifikasyon Puanı">10702</Trans>
                  </div>
                </td>
                <td className="showGrup">{employee.examScore}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="3">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Mezuniyet">10700</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {helpers.renderDate(employee.workleft)}
                </td>
              </tr>
              <tr data-dt-row="0" data-dt-column="4">
                <td>
                  <div className="tableTitle">
                    <Trans desc="E-posta">10606</Trans>
                  </div>
                </td>
                <td className="showGrup">{employee.personalEmail}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="5">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Cep Telefonu">10607</Trans>
                  </div>
                </td>
                <td className="showGrup">{employee.personalCellphone}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="6">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Referans">10703</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {this.renderReference(employee.reference)}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { employee } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">{employee.fullname}</td>
            <td className="showGrup">
              {employee.company ? employee.company.name : ""}
            </td>
            {/* <td className="showGrup">
              {employee.position ? employee.position.name : ""}
            </td> */}
            <td className="showGrup">{employee.city}</td>
            <td className="showGrup">{employee.examScore}</td>
            <td className="showGrup">
              {helpers.renderDate(employee.workleft)}
            </td>
            <td className="showGrup">{employee.personalEmail}</td>
            <td className="showGrup">{employee.personalCellphone}</td>
            <td className="showGrup">
              {this.renderReference(employee.reference)}
            </td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">{employee.fullname}</td>
            <td className="showGrup">
              {employee.company ? employee.company.name : ""}
            </td>
          </tr>
          {this.renderTabletModeDetail(employee)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(containsLongRunningProcess(requireAuth(NewGraduate)));
